import { z } from 'zod';
// Identifiants de la chaîne de traçabilité (SRS/SDD GCU — voir CLAUDE.md) : REQ-XXX-XXX-XXXX côté
// exigences, DD-XXX-XXX-XXXX côté conception. Source de vérité unique pour l'API (extraction dans
// les pages Confluence, descriptions de tickets Jira, messages de commit) et le web (affichage) — les liens se font
// sur ces identifiants, jamais sur des URL de page. Segments alphanumériques majuscules : [Supposition]
// le format exact de chaque segment (lettres vs chiffres) n'est pas figé par le ticket.
export const REQ_ID_SOURCE = String.raw `REQ-[A-Z0-9]{2,6}-[A-Z0-9]{2,6}-\d{3,5}`;
export const DD_ID_SOURCE = String.raw `DD-[A-Z0-9]{2,6}-[A-Z0-9]{2,6}-\d{3,5}`;
export function extractReqIds(text) {
    return [...new Set(text.match(new RegExp(`\\b${REQ_ID_SOURCE}\\b`, 'g')) ?? [])];
}
export function extractDdIds(text) {
    return [...new Set(text.match(new RegExp(`\\b${DD_ID_SOURCE}\\b`, 'g')) ?? [])];
}
// Ids qui ressemblent à un REQ/DD sans respecter le format (casse, segment manquant ou trop court/long,
// ex. « REQ-TRC-12 » ou « dd-trc-abc-0001 ») : probablement des fautes de frappe qui casseraient le lien.
// Les ids provisoires `REQ-TBD-<n>` / `DD-TBD-<n>` (convention des specs, volontairement hors format) sont
// exclus.
export function extractMalformedIds(text) {
    const loose = text.match(/\b(?:REQ|DD)-[A-Z0-9]+(?:-[A-Z0-9]+)*\b/gi) ?? [];
    const strict = new Set([...extractReqIds(text), ...extractDdIds(text)]);
    // Hors format de date « DD-MM-YYYY », très courant dans un message de commit ou un ticket.
    const ignored = /^(?:(?:REQ|DD)-TBD-|DD-(?:MM|YY|YYYY)(?:-|$))/i;
    return [...new Set(loose.filter((t) => !strict.has(t) && !ignored.test(t)))];
}
// Un lien Confluence collé tel quel (`.../pages/1646657539/Titre`) ou un id numérique seul : les
// deux sont acceptés, seul l'id est stocké.
export const ConfluencePageRef = z
    .string()
    .trim()
    .transform((v) => /\/pages\/(\d+)/.exec(v)?.[1] ?? v)
    .pipe(z.string().regex(/^\d{1,20}$/, 'Id ou URL de page Confluence invalide'));
// null/absent = non renseigné (affiché "not set", jamais bloquant).
export const TraceabilityConfigInput = z.object({
    srsPageId: ConfluencePageRef.nullable(),
    sddPageId: ConfluencePageRef.nullable(),
});
//# sourceMappingURL=traceability.js.map